import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-show-down",
  "use": "icon-show-down-usage",
  "viewBox": "0 0 10 7",
  "content": "<symbol viewBox=\"0 0 10 7\" fill=\"\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-show-down\">\r\n<path id=\"icon-show-down_Vector\" d=\"M0.682333 1.79032L4.52026 6.30645C4.64019 6.43548 4.8201 6.5 5 6.5C5.1799 6.5 5.35981 6.43548 5.47974 6.30645L9.31767 1.79032C9.49757 1.59677 9.55754 1.27419 9.4376 1.01613C9.31767 0.758064 9.0778 0.564516 8.83793 0.5L1.16207 0.499999C0.862236 0.499999 0.682334 0.693547 0.562398 1.01613C0.442463 1.27419 0.50243 1.59677 0.682333 1.79032Z\" fill=\"\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol